import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MomentPipePipe} from './pipes/moment-pipe.pipe';



@NgModule({
  declarations: [
    MomentPipePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MomentPipePipe
  ]
})
export class CommonPipesModule { }
